import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TripProductType, XSellBanner } from '../../../wizumen-models';
import { DropdownService } from 'projects/common/components/user-landings-v2/dropdown.service';
import { Device } from 'projects/common/model/Device';
import { animate, state, style, transition, trigger } from "@angular/animations";
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { UtilsService } from 'projects/common/services/utils.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';


@Component({
  selector: "incentive-xsell-coupon",
  template: `
    <div class="xsell-coupon-header" [ngClass]="{'separating-line': dropdownService.isDropdownOpen() && this.device?.type === 'DESKTOP', 'open-gift-icon': this.isMalbec}">
      <img *ngIf="useImg" class="xsell-coupon-icon" [ngClass]="{'open-gift-icon': this.isMalbec}" [src]="this.couponIcon" alt="incentive image" loading="lazy"/> 
      <div class="xsell-coupon-header-column" [ngClass]="{'full-width': this.fullWidth}">
        <p class="xsell-coupon-title">{{xSellBanner?.title}}</p>
        <p *ngIf="this.isMalbec && xSellBanner?.text" class="xsell-coupon-text">{{xSellBanner?.text}}</p>
        <div class="coupon-code-container flex" [ngClass]="{'copyable': this.isMalbec}">
          <div (click)="this.copyCouponCode()" class="coupon-code" [ngClass]="{'copyable': this.isMalbec, 'full-width': this.fullWidth}" [@fadeInOut]="copied ? 'hidden' : 'visible'">
            {{xSellBanner?.coupon_code}} <i class="eva-3-icon-copy -eva-3-icon-md" *ngIf="this.isMalbec"></i>
          </div>
          <div *ngIf="this.copied" class="coupon-copied" @fadeIn>
            {{xSellBanner?.coupon_copied_text}} <i class="eva-3-icon-checkmark-circle-filled -eva-3-icon-md"></i>
          </div>
          <div *ngIf="!this.isMalbec && isCouponXSellEnabled" class="flex">
            <div class="applied-coupon-text" [@fadeInOut]="couponActivated ? 'visible' : 'hidden'">
              <div>{{ 'xsell-coupon.couponApplied' | translate }}</div>
              <i class="eva-3-icon-checkmark -eva-3-icon-xsm"></i>
            </div>
            <button *ngIf="!couponActivated" content class="-md -primary eva-3-btn apply-coupon-btn"  [name]="'xsell-coupon.applyCoupon' | translate" (click)="applyCoupon()">
              <em class="btn-text">{{ 'xsell-coupon.applyCoupon' | translate }}</em>
            </button>
          </div>
        </div>
    </div>
    <i *ngIf="this.device?.type === 'DESKTOP'" class="eva-3-icon-chevron-{{dropdownService.isDropdownOpen() ? 'up' : 'down'}} dropdown-icon -eva-3-icon-md toggle-dropdown-icon" (click)="toggleDropdown()"></i>
  `,
  styleUrls: ['./incentive-xsell-coupon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 })),
      ])
    ]),
    trigger("fadeInOut", [
      state("visible", style({ display: 'flex', opacity: 1 })),
      state("hidden", style({ display: 'none', opacity: 0 })),
      transition("visible => hidden", [animate('0ms', style({ display: 'none', opacity: 0 }))]),
      transition("hidden => visible", [animate('500ms', style({ display: 'flex', opacity: 1 }))])
    ])
  ],
})
export class IncentiveXsellCouponComponent implements OnInit {
  @Input() device?: Device;
  @Input() xSellBanner?: XSellBanner;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() couponActivated: boolean = false;
  @Input() useImg = true;
  @Input() fullWidth = false;
  @Input() showApplyButton: boolean = true;
  @Output() couponActivatedChange = new EventEmitter<boolean>();

  couponIcon: string = 'https://media.staticontent.com/media/pictures/2ff94bdf-765a-4ae0-a1ff-29f278634240';
  isMalbec: boolean = false;
  copied: boolean = false;
  isCouponXSellEnabled: boolean = false;

  constructor(public dropdownService: DropdownService, public upaService: UpaService, private utilsService: UtilsService, private landingModelService: LandingModelService) {}

  ngOnInit(): void {
    if (this.xSellBanner?.type === TripProductType.XSELL_MALBEC) {
      let mediaKey = this.xSellBanner.coupon_icon || '88d1ce00-2ad4-4082-9a33-9c410a808b2b';
      this.couponIcon = `https://media.staticontent.com/media/pictures/${mediaKey}`;
      this.isMalbec = true;
    }
    this.couponActivated = this.utilsService.getCookieValue("pig-coupon-active") === "true";
    this.isCouponXSellEnabled = this.landingModelService.getLandingModel().abTests?.ab.includes("couponXSell|enabled_true");
  }

  toggleDropdown(): void {
    this.dropdownService.toggleDropdown();

    this.upaService.trackClickTopic({
      label: 'open-close-wizumen',
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.BUTTON,
      uniqueId: this.uniqueId,
    });
  }

  copyCouponCode(): void {
    if (this.xSellBanner?.coupon_code && this.isMalbec) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.xSellBanner.coupon_code);
      } else {
        // Fallback para localhost
        const input = document.createElement("input");
        input.value = this.xSellBanner.coupon_code;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }

      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 3000);

      this.upaService.trackClickTopic({
        label: 'copy-coupon-code',
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        target: UpaTarget.BUTTON,
        uniqueId: this.uniqueId,
      });
    }
  }

  applyCoupon(): void {
    this.utilsService.setCookieValue("pig-coupon-active", "true");
    this.couponActivated = true;
    this.couponActivatedChange.emit(true);
  }
}

